import Router from '../utils/router';
import SearchActionTypes from '../types/search';
import Q from 'q';

const SearchActions = { types: SearchActionTypes };

SearchActions.receiveResults = function(userIds, userNames) {
  return {
    type: SearchActions.types.RECEIVE_SEARCH_RESULTS,
    userIds: userIds,
    userNames: userNames
  };
};

SearchActions.setSearchResults = function(userIds, userNames) {
  return function(dispatch) {
    dispatch(SearchActions.receiveResults(userIds, userNames));
  };
};

export default SearchActions;
